import { SVG } from './SVG';
const IconEditSliders = () => {
  return (
    <SVG width="80" height="80" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10:2797)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.654 30.25C31.4328 34.9942 27.1263 38.4998 22.0007 38.4998C15.9257 38.4998 11.001 33.5751 11.001 27.5C11.001 21.425 15.9257 16.5002 22.0007 16.5002C27.1263 16.5002 31.4328 20.0059 32.654 24.7501H107.251C108.769 24.7501 110.001 25.9811 110.001 27.5C110.001 29.0189 108.769 30.25 107.251 30.25H32.654ZM27.5006 27.5C27.5006 30.5378 25.038 32.9999 22.0007 32.9999C18.9635 32.9999 16.5009 30.5373 16.5009 27.5C16.5009 24.4628 18.9635 22.0001 22.0007 22.0001C25.038 22.0001 27.5006 24.4622 27.5006 27.5Z"
          fill="#4062BB"
        />
        <path
          d="M2.74994 30.2499H11.3463C11.1199 29.3712 10.9998 28.4495 10.9998 27.4999C10.9998 26.5504 11.1199 25.6287 11.3463 24.75H2.74994C1.23103 24.75 0 25.981 0 27.4999C0 29.0188 1.23103 30.2499 2.74994 30.2499Z"
          fill="#4062BB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.6533 79.7501C64.4321 75.0059 60.1249 71.5002 55 71.5002C49.8751 71.5002 45.5673 75.0059 44.3467 79.7501H2.74994C1.23103 79.7501 0 80.9817 0 82.5C0 84.0183 1.23103 85.25 2.74994 85.25H44.3461C45.5673 89.9942 49.8745 93.4998 54.9994 93.4998C60.1244 93.4998 64.4321 89.9942 65.6527 85.25H107.249C108.767 85.25 109.999 84.0183 109.999 82.5C109.999 80.9817 108.767 79.7501 107.249 79.7501H65.6533ZM55 87.9999C58.0378 87.9999 60.4999 85.5378 60.4999 82.5C60.4999 79.4622 58.0378 77.0001 55 77.0001C51.9622 77.0001 49.5001 79.4622 49.5001 82.5C49.5001 85.5378 51.9622 87.9999 55 87.9999Z"
          fill="#4062BB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.6532 52.2501C97.432 47.5059 93.1248 44.0002 87.9999 44.0002C82.8749 44.0002 78.5672 47.5059 77.3466 52.2501H2.74994C1.23103 52.2501 0 53.4817 0 55C0 56.5183 1.23103 57.75 2.74994 57.75H77.3466C78.5678 62.4942 82.8749 65.9998 87.9999 65.9998C93.1248 65.9998 97.4326 62.4942 98.6532 57.75H107.249C108.768 57.75 109.999 56.5183 109.999 55C109.999 53.4817 108.768 52.2501 107.249 52.2501H98.6532ZM87.9999 60.4999C91.0377 60.4999 93.4998 58.0378 93.4998 55C93.4998 51.9622 91.0371 49.5001 87.9999 49.5001C84.9621 49.5001 82.5 51.9622 82.5 55C82.5 58.0378 84.9621 60.4999 87.9999 60.4999Z"
          fill="#4062BB"
        />
      </g>
      <defs>
        <clipPath id="clip0_10:2797">
          <rect width="110" height="110" fill="white" />
        </clipPath>
      </defs>
    </SVG>
  );
};

export { IconEditSliders as default, IconEditSliders };
